import { render, staticRenderFns } from "./languageswitcherpopup.vue?vue&type=template&id=e1a64f34&scoped=true"
import script from "./languageswitcherpopup.vue?vue&type=script&lang=js"
export * from "./languageswitcherpopup.vue?vue&type=script&lang=js"
import style0 from "./languageswitcherpopup.vue?vue&type=style&index=0&id=e1a64f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a64f34",
  null
  
)

export default component.exports